import { ref, getDownloadURL, uploadBytes, getBlob } from "firebase/storage";

async function firebaseDownloadFile(storageRef) {
  // const targetUrl = `${process.env.CMS_URL}${file.url}`;

  // try {
  //   let a = document.createElement("a");
  //   document.body.appendChild(a);
  //   a.style = "display: none";
  //   a.href = targetUrl;
  //   a.target = "_blank";
  //   a.download = file.name;
  //   a.click();
  //   // window.URL.revokeObjectURL(url);
  // } catch (e) {
  //   console.log(e);
  // }
  try {
    // const response = await getBlob(storageRef);

    let blob;
    try {
      blob = await getBlob(storageRef);
    } catch (e) {
      console.log(e);
    }

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;

    const fileName = storageRef._location.path_.split("/").pop();

    link.download = fileName;
    link.click();

    // Old code
    // respDataBlob = await response.blob();

    // let a = document.createElement("a");
    // document.body.appendChild(a);
    // a.style = "display: none";
    // let url = window.URL.createObjectURL(respDataBlob);
    // a.href = url;
    // a.download = `Appraisal_Order_${loan.Address}.pdf`;
    // a.click();
    // window.URL.revokeObjectURL(url);
    // return [];
  } catch (e) {
    console.log(e);
  }
}

export default firebaseDownloadFile;
